import React from 'react'
import {IconButton, Tooltip} from '@material-ui/core';
import Tr from 'translations/Translations';
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
	flag: {
		width: theme.spacing(3)
	}
}))

function ChangeLanguageButtonButtons(
	{
		locale,
		setLocale,
		Icon
	}) {
	const classes = useStyle();
	const handleClick = () => {
		setLocale(locale);
	}

	return (
		<Tooltip title={Tr("change_lang_" + locale)}>
			<IconButton onClick={handleClick}>
				<Icon className={classes.flag}/>
			</IconButton>
		</ Tooltip>
	)
}

export default ChangeLanguageButtonButtons;
